export const environment = {

  production: true,
  baseURL: 'https://auth.zeidman.info/',
  authURL: 'https://fa-zz-auth.azurewebsites.net/api/',
  hubURL: 'https://10bwuject1.execute-api.us-east-2.amazonaws.com/Prod/',
  hubAPIKey: '7PM0KtTUg01UxAYIiqMIf5wSAEJwTBdN82N8Ap7v',
  billingURL: 'https://fa-imp-licensing.azurewebsites.net/api/',
  billingApiKey: '5TSEYixTguwpQA3y5zRm7MvGDKv00I5KZJzezUGT9HVXnbJ4IV',
  configWebURL: 'https://fa-at-config.azurewebsites.net/',
  configWebApiKey: 'ziywP6VqA9LiRm4pm4cLuEDgEiY3tAZH',
  configAppUrl: 'https://config.zdaudit.com'
};
